/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForOpenStack extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsBaseForOpenStack");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForOpenStack.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForOpenStack>): ServiceAccountCredentialsBaseForOpenStack {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForOpenStack(), model);
        ServiceAccountCredentialsBaseForOpenStack.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForOpenStack>): ServiceAccountCredentialsBaseForOpenStack {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForOpenStack.newInstance(<ServiceAccountCredentialsBaseForOpenStack> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForOpenStack) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForOpenStack.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForOpenStack): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForOpenStack.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Username. This is a required field.
     */
    username: string;

    /**
     * Password. This is a required field.
     */
    password: string;

    /**
     * Auth URL. This is a required field.
     */
    auth_url: string;

    /**
     * Domain Name
     */
    domain: string;

    /**
     * SSL Verification disabled or not
     */
    insecure: boolean;

}
